<template>
  <div>
    <b-row class="mt-4">
      <b-col md="12">
        <b-list-group>
          <b-list-group-item
            ref="lista"
            v-for="item in listaSolicitudes.rows"
            :key="item.Id"
            style="cursor:pointer;">
            <b-card :bg-variant="(item.EstadoSolicitudMedicaString === 'Creado' ? 'light': '')" :title="item.PersonalString.toUpperCase()">
              <item-lista-solicitud :item="item"></item-lista-solicitud>
              <b-row>
                <b-col md="12" class="d-flex ">
                  <b-button-toolbar aria-label="Barra de opciones">
                    <b-button-group v-show="item.Id !== solicitudSeleccionada.id" class="mx-1">
                      <b-button variant="info" @click.stop="verDetalles(item)">Ver Detalles</b-button>
                    </b-button-group>
                    <b-button-group v-if="item.EstadoSolicitudMedicaString === 'Recibido' || item.EstadoSolicitudMedicaString === 'Creado' || item.EstadoSolicitudMedicaString === 'LicenciaFinalizada' " class="mx-1">
                      <b-button variant="secondary" v-if="isInRoleAdmin || isInRoleCoordinador || articulosEscuela.includes(item.TipoSolicitudMedicaString)" @click.stop="registrarLicencia(item)">Registrar Licencia</b-button>
                    </b-button-group>
                    <b-button-group v-if="item.EstadoSolicitudMedicaString === 'Recibido' || item.EstadoSolicitudMedicaString === 'Creado' || item.EstadoSolicitudMedicaString === 'LicenciaFinalizada' " class="mx-1">
                      <b-button variant="secondary" v-if="(isInRoleAdmin || isInRoleCoordinador) && (item.EstadoSolicitudMedicaString === 'Recibido') && !( articulosEscuela.includes(item.TipoSolicitudMedicaString))" @click.stop="agregarComentarioSolicitud(item)">Agregar Comentario</b-button>
                    </b-button-group>
                    <b-button-group class="mx-1" v-if="item.EstadoSolicitudMedicaString === 'Creado' && isInRoleEstablecimiento && (!articulosEscuela.includes(item.TipoSolicitudMedicaString))">
                      <b-dropdown right split text="Enviar solicitud">
                        <b-dropdown-item @click.stop="enviarSolicitud(item, {DisplayNivelAsignado: 'SAED', UnidadAdministrativa_Id: 1, UnidadEducativa_Id: null, NivelensEñanza_Id: null })">
                          SAED
                        </b-dropdown-item>
                      </b-dropdown>
                    </b-button-group>
                    <b-button-group class="mx-1" v-if="item.EstadoSolicitudMedicaString === 'Enviado' || item.EstadoSolicitudMedicaString == 'FueraTermino'">
                      <b-button variant="success" v-if="isInRoleAdmin || isInRoleCoordinador" @click.stop="recibirSolicitud(item, getEstablecimiento)" >Recibir solicitud</b-button>
                    </b-button-group>

                    <b-button-group class="mx-1" v-if="item.EstadoSolicitudMedicaString === 'Enviado' || item.EstadoSolicitudMedicaString == 'FueraTermino'">
                      <b-button variant="warning" v-if="isInRoleAdmin || isInRoleCoordinador" @click.stop="rechazarSolicitud(item, getEstablecimiento)">Rechazar solicitud</b-button>
                    </b-button-group>
                    <b-button-group class="mx-1" v-if="item.EstadoSolicitudMedicaString === 'Recibido'">
                      <b-button variant="warning" v-if="isInRoleAdmin || isInRoleCoordinador" @click.stop="noAutorizarSolicitud(item, getEstablecimiento)">No autorizar</b-button>
                    </b-button-group>
                    <b-button-group class="mx-1" v-if="item.EstadoSolicitudMedicaString === 'Creado' || (isInRoleAdmin && item.EstadoSolicitudMedicaString !== 'Autorizado' && item.EstadoSolicitudMedicaString !== 'AltaMedica' && item.EstadoSolicitudMedicaString !== 'LicenciaFinalizada')">
                      <b-button variant="danger" @click.stop="eliminarSolicitud(item, getEstablecimiento)">Eliminar solicitud</b-button>
                    </b-button-group>
                  </b-button-toolbar>
                </b-col>
              </b-row>
            </b-card>
            <b-row v-show="item.Id === solicitudSeleccionada.id">
              <b-col md="12" class="text-center">
                <detalle-solicitud></detalle-solicitud>
                <b-button variant="danger" size="sm" @click.stop="hide">Cerrar</b-button>
              </b-col>
            </b-row>

          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <paginacion-solicitud></paginacion-solicitud>
    <b-modal
      id="actualizarMOD"
      ref="modalActualizarEstado"
      title="Actualizar estado"
      size="md"
      ok-title="Actualizar"
      ok-variant="primary"
      cancel-title="Cancelar"
      header-bg-variant="dark"
      header-text-variant="light"
      centered>
      <b-container fluid>

      </b-container>
    </b-modal>
    <!--Modal remover-->
    <b-modal
      id="removerMOD"
      title="Eliminar Solicitud"
      size="sm"
      ok-title="Si"
      ok-variant="primary"
      cancel-title="No"
      header-bg-variant="dark"
      header-text-variant="light"
      >¿Esta seguro?</b-modal
    >
    <!--  Modal agregar cargos -->
    <b-modal
      id="modalAgregarCargos"
      title="Agregar cargos a solicitud"
      header-bg-variant="dark"
      header-text-variant="light"
      size="lg"
    ></b-modal>
  </div>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import Solicitudsvc from "@/services/solicitudes";
import LicenciaCargoPersonalSvc from "@/services/licenciacargopersonal";
import TablaBase from "../common/TablaBase.vue";
import ItemListaSolicitud from "../common/ListaSolicitudItem.vue";
import PaginacionSolicitud from "../common/PaginacionSolicitud.vue";
import DetalleSolicitud from "../common/DetalleSolicitud.vue";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'SolicitudModule/getSolicitudField',
  mutationType: 'SolicitudModule/updateSolicitudField',
});
const { mapFields: mapFormLicenciaFields } = createHelpers({
  getterType: 'FormLicenciaModule/getLicenciaField',
  mutationType: 'FormLicenciaModule/updateLicenciaField',
});
const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  name: "ListaSolicitud",
  mixins: [errorhandler, swalerts],
  props: {
  },
  watch: {
  },
  components: {
    TablaBase,
    ItemListaSolicitud,
    PaginacionSolicitud,
    DetalleSolicitud
  },
  computed: {
    ...mapFormBuscarPersonalFields(['Personal_Id', 'ListaLicencias']),
    ...mapFormLicenciaFields([
      "SolicitudSeleccionada",
      "SolicitudSeleccionada_Id"]),
    ...mapGetters([
      "isAuthenticated",
      "getUserName",
      "getUserInfo",
      "isInRoleAdmin",
      "isInRoleCoordinador",
      "isInRoleEstablecimiento",
      "getEstablecimiento"
    ]),
    ...mapFields({
      articulosEscuela: 'articulosEscuela',
      filtroEstado: 'filtro.estado',
      filtroDestino: 'filtro.destino',
      listaSolicitudes: 'tabla',
      solicitudSeleccionada: 'selected'
    }),
    paginacionActual: function(){
      return this.listaSolicitudes.perPage * this.listaSolicitudes.currentPage;
    },
    paginacionDesde: function() {
      return (this.paginacionActual - this.listaSolicitudes.perPage);
    },
    paginacionHasta: function(){
      var paginahasta = this.paginacionDesde + this.listaSolicitudes.perPage;
      if((this.listaSolicitudes.totalRows - paginahasta) < 0 ){
        return this.listaSolicitudes.totalRows;
      }
      return paginahasta;
    },
    paginacionString: function(){
      return `Mostrando ${this.paginacionDesde} a ${this.paginacionHasta} de ${this.listaSolicitudes.totalRows} items.`;
    }
  },
  data() {
    return {
      disabled: false
    };
  },
  methods: {
    ...mapActions("SolicitudModule",
    ["solicitudProvider",
    "getSolicitud", "setSelected","cambiarEstado","eliminar", "setCurrentPage"]),
    show(item) {
      this.verDetalles(item);
    },
    hide() {
      this.solicitudSeleccionada.id = -1;
    },
    verDetalles(item) {
      this.getSolicitud(item.Id);
    },
    solicitudProviderLocal(resetPagination) {
      this.disabled = true;
      console.log('resetPagination', resetPagination);
      this.solicitudProvider(resetPagination).then(r => {
        console.log('solicitudprovider then', r);

        this.disabled = false;
      });
    },
    enviarSolicitud(item, establecimiento) {
      console.log('enviarSolicitud', item, establecimiento);
      console.log('enviarSolicitud', this.listaSolicitudes.rows.length);
      var ajustarPaginacion = this.listaSolicitudes.rows.length === 1;
      this.showConfirmarInfo('Confirmar',`La solicitud ${item.Id}|${item.ToString} será enviada a ${establecimiento.DisplayNivelAsignado}.`, 'Enviar')
      .then((willChange) => {
        console.log('then willChange', willChange);
        if (willChange.isConfirmed) {
          this.cambiarEstado({
              id: item.Id,
              estado: { value: 4, text: 'Enviado'},
              nivelenseñanza_id: establecimiento.NivelEnseñanza_Id,
              unidadeducativa_id: establecimiento.UnidadEducativa_Id,
              unidadadministrativa_id: establecimiento.UnidadAdministrativa_Id,
            })
            .then(response => {
              console.log('cambiarEstado then', response);
              this.verDetalles(response.data.objeto.Editado);
              if(ajustarPaginacion){
                this.solicitudProviderLocal(1);
              }else{
                this.solicitudProviderLocal(this.listaSolicitudes.currentPage);
              }
              this.showSuccess(response.data.status.mensaje);
            })
            .catch(error => {
              this.errorHandler(error);
            });
        }
      });
    },
    rechazarSolicitud(item) {
      this.$router.push({ name: 'rechazarsolicitudpersonal', params: { solicitud: item } });
    },
    agregarComentarioSolicitud(item) {
      this.$router.push({ name: 'agregarcomentariosolicitudpersonal', params: { solicitud: item } });
    },
    noAutorizarSolicitud(item) {
      this.$router.push({ name: 'noAutorizarSolicitudpersonal', params: { solicitud: item } });
    },
    recibirSolicitud(item) {
      this.$router.push({ name: 'recibirsolicitudpersonal', params: { solicitud: item } });
    },
    // altaMedicaSolicitud(item) {
    //   this.$router.push({ name: 'altamedicasolicitudpersonal', params: { solicitud: item } });
    // },
    eliminarSolicitud(item) {
      console.log('eliminarSolicitud', item);
      console.log('eliminarSolicitud', this.listaSolicitudes.rows.length);
      var ajustarPaginacion = this.listaSolicitudes.rows.length === 1;
      this.showConfirmarDanger(`La solicitud ${item.Id}|${item.ToString} sera eliminada.`, 'Eliminar')
      .then((willDelete) => {
        console.log('then willDelete', willDelete);
        if (willDelete.isConfirmed) {
          this.eliminar(item).then(r => {
            console.log('eliminar then', r);
            if(ajustarPaginacion){
              this.solicitudProviderLocal(1);
            }else{
              this.solicitudProviderLocal(this.listaSolicitudes.currentPage);
            }
            this.showSuccess(r.data.status.mensaje);
          })
          .catch(e => {
            this.errorHandler(e);
          });
        }
      });
    },

    registrarLicencia(item) {
      Solicitudsvc.get({
        id: item.Id,
        incluyecargopersonal: true,
        incluyelicenciacargopersonal: true,
        incluyehistorialsolicitudmedica: true,
      }).then(e => {
        console.log("Solicitudsvc.get then: ", e.data);
        this.SolicitudSeleccionada = e.data.objeto;
        LicenciaCargoPersonalSvc.getLista({
          desde: ((new Date().getFullYear()) - 1) + '-01-01',
          limit: 500,
          incluyecargopersonal: true,
          personal_id: this.SolicitudSeleccionada.Personal_Id,
        }).then(l => {
          this.ListaLicencias = l.data.rows;
          console.log('registrarLicencia', item);
          this.$router.push({ name: 'registrarlicenciasolicitud', params: { solicitud_id: item.Id, dni: item.DisplayDni } });
        }).catch(err => {
          console.log("Error licenciasProvider", err);
          this.errorHandler(err);
        });;
      }).catch(error => {
        console.log("Error en Solicitudsvc.get", error.response.data);
        this.errorHandler(error);
      });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/ListaSolicitud.vue